export default __webpack_public_path__ + "static/media/info-icon-gray.2f9887c0.svg";